<template>
    <vue-plyr>
        <div class="plyr__video-embed">
            <iframe
            :src="url"
            allowfullscreen
            allowtransparency
            allow="autoplay"
            ></iframe>
        </div>
    </vue-plyr>
</template>

<script>
import VuePlyr from '@skjnldsv/vue-plyr'
import '@skjnldsv/vue-plyr/dist/vue-plyr.css'

export default {
    props: ["url"],
    components: {
        VuePlyr
    },
    data() {
        return {
        }
    }
}
</script>
